import { useNavigate } from 'react-router';
import { useAppDispatch } from '../../app/hooks';
import { logoutAndRedirect } from '../../features/authSlice';
import Modal from '../modal/Modal';

interface Props {
  closeModal: () => void;
  showModal: boolean;
}
function LogoutModal({ closeModal, showModal }: Props) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleLogout = () => {
    dispatch(logoutAndRedirect(navigate));
  };

  return (
    <Modal
      isOpen={showModal}
      onClose={closeModal}
      showCloseIcon={false}
      title='Log out from Dashboard '
    >
      <div className='flex items-center justify-center'>
        <button
          className='bg-primary px-7 py-1 text-white rounded'
          onClick={handleLogout}
        >
          Yes
        </button>
        <button className='bg-white px-5 py-1 text-pretty' onClick={closeModal}>
          Cancel
        </button>
      </div>
    </Modal>
  );
}

export default LogoutModal;
